export class SubscriptionImpl {
    constructor(cancel) {
        this.cancel = [];
        this.cancel.push(cancel);
    }
    /**
     * Register a callback to get notified is someone called #unsubscribe.
     *
     * @param callback callback to get notified if someone called #unsubscribe
     */
    onUnsubscribe(callback) {
        this.cancel.push(callback);
    }
    unsubscribe() {
        this.cancel.forEach(c => c());
    }
}
//# sourceMappingURL=Subscription.js.map